export default {
  dbu_quarter_report_title: 'Quarter Report',
  dbu_quarter_report_text1: 'Your DataBrain MBTI is:',
  dbu_quarter_report_text11: 'Data Exploration Journey',
  dbu_quarter_report_text2: '<span class="--percent">{number}%</span> of DataBrain Users',
  dbu_quarter_report_text3: 'Discover ur Databrain persona!',
  // TODO: 处理季度
  dbu_quarter_report_activity_trend: '{quarter} Active Trends',
  // TODO: 处理季度
  dbu_quarter_report_used_days: 'Total Days Used in {quarter}',
  // TODO: 处理季度
  dbu_quarter_report_total_activity: 'Total Activity in {quarter}',
  dbu_quarter_report_favourite_game: 'Favorite Game',
  dbu_quarter_report_favourite_genre: 'Favorite Genre',
  dbu_quarter_report_context_menu_tips: 'Right-click to save the full image',

  // Highlight moment related
  dbu_quarter_report_highlight_moment: 'Quarterly Highlights',
  // TODO: 处理季度
  dbu_quarter_report_most_visited_page: 'Most Visited Page in {quarter}',
  dbu_quarter_report_visited_game_on_date: 'On this day,\nyou viewed 《{gameName}》',
  dbu_quarter_report_visited_databrain_on_date: 'On this day,\nyou accessed DataBrain over',
  dbu_quarter_report_times_unit: 'times',

  // User preference related
  dbu_quarter_report_game_preference_profile: 'Gaming Preferences',
  dbu_quarter_report_favourite_game_top3: 'Favorite Games',
  dbu_quarter_report_top3_label: 'TOP3',
  dbu_quarter_report_favourite_entity_type: 'Favorite Category',

  // QR code related
  dbu_quarter_report_scan_to_miniprogram: 'Scan to visit DataBrain Mini Program',
  dbu_quarter_report_scan_instruction_1: 'Top right corner',
  dbu_quarter_report_scan_user_center: 'User Center',
  dbu_quarter_report_scan_quarterly_mbti: 'Quarterly MBTI',
  dbu_quarter_report_scan_instruction_3: 'Get your exclusive data gene card and share your gaming data MBTI!',

  dbu_quarter_report_game_data_gene_name_e: 'Voyager',
  dbu_quarter_report_game_data_gene_name_i: 'Sniper',
  dbu_quarter_report_game_data_gene_name_s: 'Genre Master',
  dbu_quarter_report_game_data_gene_name_n: 'Trend Hunter',
  dbu_quarter_report_game_data_gene_name_t: 'Data Whiz',
  dbu_quarter_report_game_data_gene_name_f: 'Opinion Decoder',
  dbu_quarter_report_game_data_gene_name_j: 'In-house Curator',
  dbu_quarter_report_game_data_gene_name_p: 'Sector Maven',
  dbu_quarter_report_game_data_gene_description_e: 'Explores diverse pages',
  dbu_quarter_report_game_data_gene_description_i: 'Reads pages attentively',
  dbu_quarter_report_game_data_gene_description_s: 'Has specific preferences in a vast game library',
  dbu_quarter_report_game_data_gene_description_n: 'Identify industry trends',
  dbu_quarter_report_game_data_gene_description_t: 'Focuses on measurable game performance',
  dbu_quarter_report_game_data_gene_description_f: 'Understands player sentiment and trends',
  dbu_quarter_report_game_data_gene_description_j: 'Analyzes the internal ecosystem',
  dbu_quarter_report_game_data_gene_description_p: 'Evaluates the benchmark',

  // Quarter selector
  dbu_quarter_report_unavailable: 'No data available',
  dbu_quarter_report_select_quarter: 'Select Quarter',


  // 2025 Game Names
  dbu_quarter_report_2025_game_name_1: '命运守护夜Fate',
  dbu_quarter_report_2025_game_name_2: '最终幻想VII',
  dbu_quarter_report_2025_game_name_3: 'Fate/Zero',
  dbu_quarter_report_2025_game_name_4: '哈利波特',
  dbu_quarter_report_2025_game_name_5: '绝代双骄',
  dbu_quarter_report_2025_game_name_6: '三丽鸥',
  dbu_quarter_report_2025_game_name_7: '崩坏：星轨',
  dbu_quarter_report_2025_game_name_8: '王者荣耀',
  dbu_quarter_report_2025_game_name_9: '无敌破坏王',
  dbu_quarter_report_2025_game_name_10: '海贼王',
  dbu_quarter_report_2025_game_name_11: '英雄联盟',
  dbu_quarter_report_2025_game_name_12: 'Durarara!!',
  dbu_quarter_report_2025_game_name_13: '妖精的尾巴',
  dbu_quarter_report_2025_game_name_14: '鬼灭之刃',
  dbu_quarter_report_2025_game_name_15: '漫威系列游戏',

  // 2025 Role Names
  dbu_quarter_report_2025_role_name_istj: 'Artoria',
  dbu_quarter_report_2025_role_name_isfj: 'Tifa',
  dbu_quarter_report_2025_role_name_infj: 'Kiritsugu Emiya',
  dbu_quarter_report_2025_role_name_intj: 'Severus Snape',
  dbu_quarter_report_2025_role_name_istp: 'Hua Wuque',
  dbu_quarter_report_2025_role_name_isfp: 'Kuromi',
  dbu_quarter_report_2025_role_name_infp: 'Firefly',
  dbu_quarter_report_2025_role_name_intp: 'Luna',
  dbu_quarter_report_2025_role_name_estp: 'Vanellope von Schweetz',
  dbu_quarter_report_2025_role_name_esfp: 'Boa Hancock',
  dbu_quarter_report_2025_role_name_enfp: 'Jinx',
  dbu_quarter_report_2025_role_name_entp: 'Izaya Orihara',
  dbu_quarter_report_2025_role_name_estj: 'Erza Scarlet',
  dbu_quarter_report_2025_role_name_esfj: 'Daji',
  dbu_quarter_report_2025_role_name_enfj: 'Tanjiro Kamado',
  dbu_quarter_report_2025_role_name_entj: 'Iron Man',

  // 2025 Role Exclusive Copy
  dbu_quarter_report_2025_role_exclusive_copy_istj:
    'Excalibur! As the steadfast King of DataBrain, you safeguard timeless data with unwavering dedication, your insights a beacon of trust.',
  dbu_quarter_report_2025_role_exclusive_copy_isfj:
    'In quietude, you underpin the entire world, protecting a reliable "Seventh Heaven", where every player can moor with peace of mind by decoding players\' footprints and whispers.',
  dbu_quarter_report_2025_role_exclusive_copy_infj:
    'You are a forward-thinking strategist within the DataBrain world, skilled at grasping the essence of the gaming world from data to formulate strategies for long-term goals.',
  dbu_quarter_report_2025_role_exclusive_copy_intj:
    'The market is like a complex potion, and the DataBrain platform your very own laboratory where you concoct the gaming world\'s timeless classics with precise formulas.',
  dbu_quarter_report_2025_role_exclusive_copy_istp:
    'At DataBrain, you strip away all needless noise and emotion, leaving the core data and reason in its wake, flawlessly executing a perfect combo, without a word.',
  dbu_quarter_report_2025_role_exclusive_copy_isfp:
    'You never follow the mainstream radar, trusting in your wild hunches to dodge those commonplace charts and pinpoint the hidden gem about to explode onto the scene.',
  dbu_quarter_report_2025_role_exclusive_copy_infp:
    'You are a wanderer seeking secrets within the data dreamscape, steering clear of glitzy facades, unearthing the genuine emotional connections hidden deep within the data.',
  dbu_quarter_report_2025_role_exclusive_copy_intp:
    'Here in the DataBrain world, you silently seek out links between the markers, charting the most optimised path, and using a seamless "Moonlit Infinite Combo" to pierce through the superficial.',
  dbu_quarter_report_2025_role_exclusive_copy_estp:
    'Here at DataBrain, you\'re that maverick player who spies a "system glitch", getting your kicks from drifting at breakneck speed through sprawling data sets, gaining a head start in uncharted waters.',
  dbu_quarter_report_2025_role_exclusive_copy_esfp:
    'Here at DataBrain, it\'s your personal "taste" and "flair" that steers you across this data sea; only games that dazzle and delight you earn a place on your radar.',
  dbu_quarter_report_2025_role_exclusive_copy_enfp:
    'Bang, bang, bang! Bombarding DataBrain with explosive curiosity, you\'re the loose cannon roaming through data canyons, using intuition and passion to ignite the next trend and dazzle everyone!',
  dbu_quarter_report_2025_role_exclusive_copy_entp:
    '"Humans, LOVE!" At DataBrain, you enjoy unraveling the mysteries within the massive datasets and predicting the next big thing. This platform is your ultimate playground – your Ikebukuro.',
  dbu_quarter_report_2025_role_exclusive_copy_estj:
    'As the "Fairy Queen" of the DataBrain world, you can summon the perfect data strategy for every challenge, holding fast to the belief that a clear aim and unfailing execution are the only path to triumph.',
  dbu_quarter_report_2025_role_exclusive_copy_esfj:
    '"Let Daji see your heart~" You are DataBrain\'s very own enchanting fox spirit, effortlessly deciphering the real emotion behind the data and heralding the coming tide with an unparalleled grasp of player emotion.',
  dbu_quarter_report_2025_role_exclusive_copy_enfj:
    '"心を燃やせ！" (Set your heart ablaze!) Your kindness and empathy are your greatest strengths, granting you the ability to perceive the most sincere feelings and longings of users.',
  dbu_quarter_report_2025_role_exclusive_copy_entj:
    '"Jarvis, run the numbers." You\'re DataBrain\'s most far-sighted strategist, unfolding the entire gaming market\'s blueprint from the data, with every play defining the formula for the next blockbuster.',


  // 2026 Game Names
  dbu_quarter_report_2026_game_name_1: 'Love and Deepspace',
  dbu_quarter_report_2026_game_name_2: 'SPY×FAMILY',
  dbu_quarter_report_2026_game_name_3: 'Kaguya-sama: Love Is War', 
  dbu_quarter_report_2026_game_name_4: 'Jujutsu Kaisen',
  dbu_quarter_report_2026_game_name_5: 'Attack on Titan',
  dbu_quarter_report_2026_game_name_6: 'Demon Slayer',
  dbu_quarter_report_2026_game_name_7: 'NIKKE',
  dbu_quarter_report_2026_game_name_8: 'BanG Dream!',
  dbu_quarter_report_2026_game_name_9: 'Mr. Love: Queen\'s Choice',
  dbu_quarter_report_2026_game_name_10: 'The Quintessential Quintuplets',
  dbu_quarter_report_2026_game_name_11: 'Kamisama Kiss',
  dbu_quarter_report_2026_game_name_12: 'Chainsaw Man',

  // 2026 Role Names
  dbu_quarter_report_2026_role_name_istj: 'Zayne (Li Shen)',
  dbu_quarter_report_2026_role_name_isfj: 'Yor (Briar) Forger',
  dbu_quarter_report_2026_role_name_infj: 'Ai Hayasaka',
  dbu_quarter_report_2026_role_name_intj: 'Suguru Getō',
  dbu_quarter_report_2026_role_name_istp: 'Levi Ackerman',
  dbu_quarter_report_2026_role_name_isfp: 'Eren Yeager',
  dbu_quarter_report_2026_role_name_infp: 'Muichiro Tokito',
  dbu_quarter_report_2026_role_name_intp: 'Shen Xinghui',
  dbu_quarter_report_2026_role_name_estp: 'Red Hood',
  dbu_quarter_report_2026_role_name_esfp: 'Anon Chihaya',
  dbu_quarter_report_2026_role_name_enfp: 'Qi\u2011Luo "Kiro" Zhou',
  dbu_quarter_report_2026_role_name_entp: 'Satoru Gojo',
  dbu_quarter_report_2026_role_name_estj: 'Nino Nakano',
  dbu_quarter_report_2026_role_name_esfj: 'Nanami Momozono',
  dbu_quarter_report_2026_role_name_enfj: 'Makima',
  dbu_quarter_report_2026_role_name_entj: 'Dorothy',

  // 2026 Role Exclusive Copy
  dbu_quarter_report_2026_role_exclusive_copy_istj:
    'You treat every dataset as a letter waiting to be deciphered, using cardiac\u2011surgery\u2011level precision to uncover users\' truest desires and needs between the lines.',
  dbu_quarter_report_2026_role_exclusive_copy_isfj:
    'You need no words, quietly guarding that one precious box of data, sensing the deepest wishes in users\' hearts with warmth and resilience beyond speech.',
  dbu_quarter_report_2026_role_exclusive_copy_infj:
    '"This is also part of the job." On DataBrain, you slip between different "roles" of analysis with ease, using maid\u2011like composure and insight to quietly guide lost trends back on track.',
  dbu_quarter_report_2026_role_exclusive_copy_intj:
    'Believing that truth belongs only to an elite few, you use meticulous data calculation to plan every step toward your goal and build a clear world open only to "sorcerers."',
  dbu_quarter_report_2026_role_exclusive_copy_istp:
    'Wielding analytical blades like ODM Gear, you navigate massive data with precision, striking the "nape" of a problem\'s core at maximum speed.',
  dbu_quarter_report_2026_role_exclusive_copy_isfp:
    'To see the scenery beyond the walls, you drive the data with an unyielding will, launching Rumbling\u2011like advances again and again toward the freedom you believe in.',
  dbu_quarter_report_2026_role_exclusive_copy_infp:
    'Like ethereal Mist Breathing, you cut through the fog of data with inspired intuition, catching that single ray of light that reveals the essence in quiet contemplation.',
  dbu_quarter_report_2026_role_exclusive_copy_intp:
    '"My light will find the answer." Seemingly laid\u2011back, you carry a hunter\'s instinct, using light\u2011speed intuition to capture the crucial variable hidden in complex data.',
  dbu_quarter_report_2026_role_exclusive_copy_estp:
    'You are the out\u2011of\u2011control "Red Beast" beyond the Ark, racing through the data wilderness on instinct and firepower, seizing every fleeting opportunity with a clean, decisive shot.',
  dbu_quarter_report_2026_role_exclusive_copy_esfp:
    'You are the Flames of Finality that ignite adversity, turning every critical swing in the data into a shining melody of hope with your bright, innocent passion.',
  dbu_quarter_report_2026_role_exclusive_copy_enfp:
    'With idol\u2011level charm, you weave scattered market rumors and player stories into light\u2011footed poems, playing a romantic symphony of data innovation.',
  dbu_quarter_report_2026_role_exclusive_copy_entp:
    '"Don\'t worry. I\'m the strongest." On DataBrain, you expand a domain like Unlimited Void, making all complex data and information reveal itself before your limitless insight.',
  dbu_quarter_report_2026_role_exclusive_copy_estj:
    'Just like guarding the bond with your sisters, you assert firm control over data\'s order, ensuring no target strays from your plan through direct and efficient action.',
  dbu_quarter_report_2026_role_exclusive_copy_esfj:
    'With warm empathy, you connect scattered data into a living community, giving every player on DataBrain a sense of belonging like a cherished shrine.',
  dbu_quarter_report_2026_role_exclusive_copy_enfj:
    '"This is an order." On DataBrain, with gentle yet absolute control, you marshal vast market data, turning it into the "eyes" and intelligence network that work only for you.',
  dbu_quarter_report_2026_role_exclusive_copy_entj:
    '"Paradise should look like paradise." With a queen\'s vision and exacting standards, you command data to build an ideal paradise that leads straight to perfect victory.',
};
